export default "__VITE_ASSET__12555124__"